import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DropdownComponent } from '../dropdown/dropdown.component';

/**
 * Sample usage:
 *
 *     <accordion [value]="sort.option"
 *               (valueChange)="sort.by($event)"
 *               [options]="sort.getOptions()">
 *         <ng-template #titleTpl>{{sort.selectionLabel}}</ng-template>
 *         <ng-template #optionTpl let-option>{{option.label}}</ng-template>
 *     </accordion>
 */
@Component({
    selector: 'accordion',
    templateUrl: './accordion.html',
    styleUrls: ['./accordion.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionComponent<T> extends DropdownComponent<T> {}
